import { render, staticRenderFns } from "./detailsNew.vue?vue&type=template&id=a4c58ba4&scoped=true&"
import script from "./detailsNew.vue?vue&type=script&lang=js&"
export * from "./detailsNew.vue?vue&type=script&lang=js&"
import style0 from "./detailsNew.vue?vue&type=style&index=0&id=a4c58ba4&lang=scss&scoped=true&"
import style1 from "./detailsNew.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c58ba4",
  null
  
)

export default component.exports